module.exports = __webpack_public_path__ + "static/media/trumpet.e0333ed6.svg";